import AnimationMoveBottom from "./animation-move-bottom";
import AnimationMoveLeft from "./animation-move-left";
import AnimationMoveRight from "./animation-move-right";
import AnimationMoveTop from "./animation-move-top";
import BounceLeft from "./bounce-left";
import BounceRight from "./bounce-right";
import EaseCurveControlPoints from "./ease-curve-control-points";
import EaseIn from "./ease-in";
import EaseInControlPoint from "./ease-in-control-point";
import EaseInOut from "./ease-in-out";
import EaseOut from "./ease-out";
import EaseOutControlPoint from "./ease-out-control-point";
import Keyframe from "./keyframe";
import KeyframeAdd from "./keyframe-add";
import KeyframeAlignCenter from "./keyframe-align-center";
import KeyframeAlignHorizontal from "./keyframe-align-horizontal";
import KeyframeAlignVertical from "./keyframe-align-vertical";
import KeyframeBottom from "./keyframe-bottom";
import KeyframeLeft from "./keyframe-left";
import KeyframeRemove from "./keyframe-remove";
import KeyframeRight from "./keyframe-right";
import KeyframeTop from "./keyframe-top";
import KeyframeDouble from "./keyframes-double";
import KeyframeDoubleRemove from "./keyframes-double-remove";
import KeyframeMultiple from "./keyframes-multiple";
import KeyframeMultipleAdd from "./keyframes-multiple-add";
import KeyframeMultipleRemove from "./keyframes-multiple-remove";
import Liner from "./liner";
import Motion01 from "./motion-01";
import Motion02 from "./motion-02";
import TransitionBottom from "./transition-bottom";
import TransitionLeft from "./transition-left";
import TransitionRight from "./transition-right";
import TransitionTop from "./transition-top";

export * from "./bounce-left";
export * from "./bounce-right";
export * from "./ease-curve-control-points";
export * from "./ease-in";
export * from "./ease-in-control-point";
export * from "./ease-in-out";
export * from "./ease-out";
export * from "./ease-out-control-point";
export * from "./keyframe";
export * from "./keyframe-add";
export * from "./keyframe-align-center";
export * from "./keyframe-align-horizontal";
export * from "./keyframe-align-vertical";
export * from "./keyframe-bottom";
export * from "./keyframe-left";
export * from "./keyframe-remove";
export * from "./keyframe-right";
export * from "./keyframes-double";
export * from "./keyframes-double-remove";
export * from "./keyframes-multiple";
export * from "./keyframes-multiple-add";
export * from "./keyframes-multiple-remove";
export * from "./keyframe-top";
export * from "./liner";
export * from "./motion-01";
export * from "./motion-02";
export * from "./animation-move-bottom";
export * from "./animation-move-left";
export * from "./transition-right";
export * from "./animation-move-top";
export * from "./transition-bottom";
export * from "./transition-left";
export * from "./transition-right";
export * from "./transition-top";

export const Animations = {
  AnimationMoveBottom,
  AnimationMoveLeft,
  AnimationMoveRight,
  AnimationMoveTop,
  BounceLeft,
  BounceRight,
  EaseCurveControlPoints,
  EaseIn,
  EaseInControlPoint,
  EaseInOut,
  EaseOut,
  EaseOutControlPoint,
  Keyframe,
  KeyframeAdd,
  KeyframeAlignCenter,
  KeyframeAlignHorizontal,
  KeyframeAlignVertical,
  KeyframeBottom,
  KeyframeLeft,
  KeyframeRemove,
  KeyframeRight,
  KeyframeDouble,
  KeyframeDoubleRemove,
  KeyframeMultiple,
  KeyframeMultipleAdd,
  KeyframeMultipleRemove,
  KeyframeTop,
  Liner,
  Motion01,
  Motion02,
  TransitionLeft,
  TransitionRight,
  TransitionTop,
  TransitionBottom,
};
